<template>
  <div>
    <router-view/>
    <alerts group="app" position="bottom right"/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import VT from '@/store/types';
import { Backend } from '@/_axios';

export default {
  name: 'app',
  mounted() {
    this.setAuthToken(this.token);
    // this.setAbilities(this.abilities);
    this[VT.LOAD_USER_INFO]().then(() => {
      this[VT.PROJECT_LOAD](this.activeProjectId);
    }).catch(() => { });
  },
  computed: {
    ...mapState('Auth', ['activeProjectId', 'token']),
  },
  watch: {},
  methods: {
    ...mapActions('Auth', [VT.LOAD_USER_INFO]),
    ...mapActions('Project', [VT.PROJECT_LOAD]),
    setAuthToken(token) {
      if (token && token.length > 0) {
        Backend.defaults.headers['Authorization'] = `Bearer ${token}`;
      }
    },
  },
};

</script>

<style lang="scss">
// CoreUI Icons Set
@import '~@coreui/icons/css/coreui-icons.min.css';
/* Import Font Awesome Icons Set */
$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome.scss';
/* Import Simple Line Icons Set */
$simple-line-font-path: '~simple-line-icons/fonts/';
@import '~simple-line-icons/scss/simple-line-icons.scss';
/* Import Flag Icons Set */
@import '~flag-icon-css/css/flag-icon.min.css';
/* Import Bootstrap Vue Styles */
@import '~bootstrap-vue/dist/bootstrap-vue.css';
// Import Main styles for this application
@import 'assets/scss/style';
</style>
